import { GROUP_TYPES } from '../values/meetings.values';
import { Student } from './student-front.model';

export class RequestMeetingFront{
  meetingId: number;
  meetingSetId?: number;
  name: string;
  description?: string;
  active?: boolean;
  editable: boolean;
  startingDate?: string;
  type: GROUP_TYPES;
  classId: number;
  className?: string;
  rooms?: Array<RequestMeetingFront>;
  students?: Array<Student>;
  justCreated?: boolean;

  constructor(data){
    this.meetingId = data.meetingId;
    this.meetingSetId = data.meetingSetId;
    this.name = data.name;
    this.description = data.description;
    this.active = data.active;
    this.editable = data.editable;
    this.startingDate = data.startingDate;
    this.type = data.type;
    this.classId = data.classId;
    this.className = data.className;
    this.rooms = data.rooms ? data.rooms : null;
    this.students = data.students ? data.students : null;
    this.justCreated = data.justCreated;
  }
}
